import React, { useState } from "react";
import "./GrowthControlSection.css";

const leftItems = [
  {
    title: "Smart domain control",
    text: "Manage nameservers, DNS, renewals, and ownership settings from one clean dashboard built for quick action.",
  },
  {
    title: "Reliable brand protection",
    text: "Keep your domain secure with SSL-ready setup, privacy-friendly tools, and safer account access.",
  },
];

const rightItems = [
  {
    title: "Hosting-ready setup",
    text: "Connect your domain with hosting, email, and business tools without complex technical steps.",
  },
  {
    title: "Built for growing teams",
    text: "Give startups, creators, and agencies a smooth way to launch, manage, and scale their online presence.",
  },
];

const GrowthControlSection = () => {
  const [openLeft, setOpenLeft] = useState(0);
  const [openRight, setOpenRight] = useState(0);

  const renderItems = (items, openIndex, setOpenIndex) =>
    items.map((item, index) => {
      const isOpen = openIndex === index;

      return (
        <article className="gc-item" key={item.title}>
          <button
            type="button"
            className="gc-title"
            onClick={() => setOpenIndex(isOpen ? -1 : index)}
          >
            <span>{item.title}</span>
            <strong>{isOpen ? "−" : "+"}</strong>
          </button>

          {isOpen && <p>{item.text}</p>}
        </article>
      );
    });

  return (
    <section className="gc-section">
      <div className="gc-container">
        <div className="gc-column">
          <div className="gc-icon">✦</div>
          <h2>Control your online foundation</h2>
          {renderItems(leftItems, openLeft, setOpenLeft)}
        </div>

        <div className="gc-column">
          <div className="gc-icon gc-icon-alt">↗</div>
          <h2>Launch faster with confidence</h2>
          {renderItems(rightItems, openRight, setOpenRight)}
        </div>
      </div>
    </section>
  );
};

export default GrowthControlSection;